import React, { useState, useEffect } from "react";
import AdminPasswordProtection from "./AdminPasswordProtection";

const ProtectedAdminRoute = ({ children }) => {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  // Check if admin is already authenticated (from localStorage)
  useEffect(() => {
    const adminAuthStatus = localStorage.getItem(
      "lavvissa_admin_authenticated"
    );
    if (adminAuthStatus === "true") {
      setIsAdminAuthenticated(true);
    }
  }, []);

  const handleAdminAuthentication = () => {
    setIsAdminAuthenticated(true);
    localStorage.setItem("lavvissa_admin_authenticated", "true");
  };

  // If not authenticated as admin, show admin password protection
  if (!isAdminAuthenticated) {
    return (
      <AdminPasswordProtection onAuthenticated={handleAdminAuthentication} />
    );
  }

  // If authenticated as admin, show the admin content
  return children;
};

export default ProtectedAdminRoute;
